import { MaskitoOptions } from '@maskito/core';

import { detectBrazilianDocumentKind, normalizeBrazilianDocument } from './normalize';

const CPF_DIGIT = /\d/;
const CNPJ_BODY_CHAR = /[0-9A-Za-z]/;
const CNPJ_CHECK_DIGIT = /\d/;

const CPF_MASK = [
  CPF_DIGIT, CPF_DIGIT, CPF_DIGIT, '.',
  CPF_DIGIT, CPF_DIGIT, CPF_DIGIT, '.',
  CPF_DIGIT, CPF_DIGIT, CPF_DIGIT, '-',
  CPF_DIGIT, CPF_DIGIT,
] as const;

const CNPJ_MASK = [
  CNPJ_BODY_CHAR, CNPJ_BODY_CHAR, '.',
  CNPJ_BODY_CHAR, CNPJ_BODY_CHAR, CNPJ_BODY_CHAR, '.',
  CNPJ_BODY_CHAR, CNPJ_BODY_CHAR, CNPJ_BODY_CHAR, '/',
  CNPJ_BODY_CHAR, CNPJ_BODY_CHAR, CNPJ_BODY_CHAR, CNPJ_BODY_CHAR, '-',
  CNPJ_CHECK_DIGIT, CNPJ_CHECK_DIGIT,
] as const;

function shouldUseCnpjMask(value: string): boolean {
  const clean = normalizeBrazilianDocument(value);
  return detectBrazilianDocumentKind(clean) === 'cnpj';
}

/** Máscara apenas para CPF (campos exclusivos de pessoa física). */
export const patternCpfMask: MaskitoOptions = {
  mask: [...CPF_MASK],
};

/** Máscara para CNPJ numérico ou alfanumérico. */
export const patternCnpjMask: MaskitoOptions = {
  mask: [...CNPJ_MASK],
  preprocessors: [
    ({ elementState, data }) => ({
      elementState,
      data: data.toUpperCase(),
    }),
  ],
};

/**
 * Máscara dinâmica CPF/CNPJ.
 * Alterna para CNPJ ao digitar letra ou ultrapassar 11 caracteres do corpo.
 */
export const patternCpfCnpjMask: MaskitoOptions = {
  mask: ({ value }) => (shouldUseCnpjMask(value) ? [...CNPJ_MASK] : [...CPF_MASK]),
  preprocessors: [
    ({ elementState, data }) => ({
      elementState,
      data: data.toUpperCase(),
    }),
  ],
};
